import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Row, Col, FormGroup, FormLabel, FormControl } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Card from "../../components/Card/Card.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";
import { useAuth } from "../../contexts/authContext";
import SelectListControl from "../../components/Fields/SelectListControl";
import SpinnerOverlay from "../../components/Spinner/SpinnerOverlay";
import { SelectListOption } from "../../components/Fields/Types.jsx";

interface IState {
    from: string
}

const Login: React.FC = () => {
    const { isAuthenticated, login } = useAuth();
    const [showSpinner, setShowSpinner] = useState(false);
    const [username, setUsername] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [connectionStringName, setConnectionStringName] = useState<string>()
    const [cardHidden, setCardHidden] = useState<boolean>(true);
    const [alert, setAlert] = useState<SweetAlert>();
    const [authenticated, setAuthenticated] = useState<boolean>(isAuthenticated())
    const location = useLocation();
    const navigate = useNavigate();

    let returnUrl = "/plm/home"
    if (location && location.state) {
        const state: IState = location.state as IState
        returnUrl = state.from;
    }

    let connectionStringNames: SelectListOption[] = [];
    var hostname = window.location.hostname;
    switch (hostname) {
        case 'localhost':
            connectionStringNames.push({ value: "DefaultConnection.dev", label: "Development" })
            connectionStringNames.push({ value: "DefaultConnection.tst", label: "Test" })
            connectionStringNames.push({ value: "DefaultConnection.prd", label: "Production" })
            break;
        case 'plmtest.difuzed.com':
            connectionStringNames.push({ value: "DefaultConnection.tst", label: "Test" })
            break;
        case 'plmtst2':
            connectionStringNames.push({ value: "DefaultConnection.tst", label: "Test" })
            connectionStringNames.push({ value: "DefaultConnection.prd", label: "Production" })
            break;
        case 'plm2':
        case 'plm.difuzed.com':
            connectionStringNames.push({ value: "DefaultConnection.prd", label: "Production" })
            break;
    }

    if (connectionStringNames.length >= 1 && connectionStringName == undefined)
        setConnectionStringName(connectionStringNames[0].value.toString())

    //console.log('cnn', connectionStringNames);
    //console.log('location:', window.location)

    setTimeout(function () {
        setCardHidden(false);
    }, 700);

    function onChangeUsername(e) {
        setUsername(e.target.value);
    }

    function onChangePassword(e) {
        setPassword(e.target.value);
    }

    function onChangeConnection(value) {
        setConnectionStringName(value);
    }

    function handleLogin(e) {
        e.preventDefault();
        setShowSpinner(true);

        if (connectionStringName) {
            login(username, password, connectionStringName, function (result) {
                setShowSpinner(false);
                if (result.isSuccesful) {
                    setAuthenticated(true);
                }
                else {
                    const message = result.messages[0].message.format ?? result.messages[0].message;
                    setAlert(
                        <SweetAlert title="Login" style={{ display: "block", marginTop: "-100px" }} onConfirm={() => setAlert(null)}>
                            {message}
                        </SweetAlert>
                    );
                }
            })
        }
    }

    if (authenticated)
        navigate(returnUrl)

    return (
        <div>
            {alert}
            <Container>
                <Row>
                    <Col md={{ span: 4, offset: 4 }} sm={{ span: 6, offset: 3 }}>
                        <form>
                            <Card hidden={cardHidden} textCenter title="Login" ftTextCenter
                                content={
                                    <div>
                                        {connectionStringNames.length > 1 && (
                                            <FormGroup>
                                                <FormLabel>Database</FormLabel>
                                                <SelectListControl name='Database' value={connectionStringName} onChange={onChangeConnection} options={connectionStringNames} validationResults={[]} />
                                            </FormGroup>
                                         )}
                                        <FormGroup>
                                            <FormLabel>Username</FormLabel>
                                            <FormControl placeholder="Enter username" type="text" value={username} onChange={onChangeUsername} />
                                        </FormGroup>
                                        <FormGroup>
                                            <FormLabel>Password</FormLabel>
                                            <FormControl placeholder="Password" type="password" /*autoComplete="off"*/ value={password} onChange={onChangePassword} />
                                        </FormGroup>
                                    </div>
                                }
                                legend={
                                    <Button fill wd onClick={handleLogin}>Login</Button>
                                }
                            />
                            {showSpinner && <SpinnerOverlay />}
                        </form>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}
export default Login;
